<template>
    <div id="content" class="calls">
        <loader></loader>
        <div class="top" ref="top">
            <div class="header">
                <h1>Historique des appels</h1>
<!--                <div class="pageOptions">-->
<!--                    <Btn text="Exporter" ico="download" v-if="$store.getters.hasPerm('call:export')" @click="exports(csvData)"></Btn>-->
<!--                    <Btn text="Stats" ico="download" v-if="$store.getters.hasPerm('call:export')" @click="stats(csvStats)"></Btn>-->
<!--                </div>-->
            </div>
            <div class="options">
                <div class="searchBar pickDate ">
                    <!--                    <input type="date" placeholder="Date début" v-model="date_start"/>-->
                    <!--                    <input type="date" placeholder="Date fin" v-model="date_end"/>-->
                    <DatePicker mode='range' v-model='dateRange'></DatePicker>
                </div>
                <div class="searchBar drop">
                    <multi-list-select
                            :list="users"
                            :selectedItems="usersSelect"
                            option-value="id"
                            :custom-text="user"
                            placeholder="Sélectionner une secrétaire"
                            :isDisabled="!$store.getters.hasPerm('call:add/edit:user')"
                            @select="onSelectUser">
                    </multi-list-select>
                </div>
                <div class="searchBar drop">
                    <multi-list-select
                            :list="customers"
                            :selectedItems="customersSelect"
                            option-value="id"
                            option-text="company"
                            placeholder="Sélectionner un client"
                            @select="onSelectCustomer">
                    </multi-list-select>
                </div>
                <div class="searchBar drop">
                    <multi-list-select
                            :list="reasons"
                            :selectedItems="reasonsSelect"
                            option-value="id"
                            option-text="label"
                            placeholder="Sélectionner un motif"
                            @select="onSelectReason">
                    </multi-list-select>
                </div>
                <btn ico="times" color="red" @click="resetSearch"></btn>
            </div>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                <tr>
                    <th :style="{'top':stickyTop+'px'}">
                        Date
                        <table-order name="date_hours_start" @change="changeOrder"></table-order>
                    </th>
                    <th :style="{'top':stickyTop+'px'}">
                        Client
                        <table-order name="customer.company" @change="changeOrder"></table-order>
                    </th>
                    <th :style="{'top':stickyTop+'px'}">
                        Secretaire
                        <table-order name="user.login" @change="changeOrder"></table-order>
                    </th>
                    <th :style="{'top':stickyTop+'px'}">
                        Motifs Appels
                        <table-order name="reason.label" @change="changeOrder"></table-order>
                    </th>
                    <th :style="{'top':stickyTop+'px'}">
                        Observation
                        <table-order name="observation" @change="changeOrder"></table-order>
                    </th>
                    <th :style="{'top':stickyTop+'px'}">
                        NB RDV
                        <table-order name="call_meet" @change="changeOrder"></table-order>
                    </th>
                    <th :style="{'top':stickyTop+'px'}">
                        Date Validation
                        <table-order name="date_hours_validation" @change="changeOrder"></table-order>
                    </th>
                    <th :style="{'top':stickyTop+'px'}">
                        Options
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(call,key) in visibles">
                    <td>{{call.date_hours_start|formatDateHour}}</td>
                    <td>{{call.customer.company}}</td>
                    <td>{{user(call.user)}}</td>
                    <td>{{callReasonResume(call)}}</td>
                    <td>{{call.observation}}</td>
                    <td>{{calculCallMeet(call)}}</td>
                    <td>{{call.date_hours_validation|formatDateHour}}</td>
                    <td class="tableOptions">
                        <div v-if="$store.getters.hasPerm('call:show') && !$store.getters.hasPerm('call:edit') && !editLimit(call)" @click="show(call)" title="Afficher l'appel">
                            <svg class="option">
                                <use xlink:href="#icon-eye"></use>
                            </svg>
                        </div>
                        <div v-if="$store.getters.hasPerm('call:edit') || editLimit(call)" @click="edit(call)" title="Modifier l'appel">
                            <svg class="option">
                                <use xlink:href="#icon-edit"></use>
                            </svg>
                        </div>
                    </td>
                </tr>
                <tr v-if="visibles.length <= 0">
                    <td colspan="8" style="text-align: center">Il n'y a aucun appel</td>
                </tr>
                </tbody>
            </table>
        </div>
        <pagination :current="currentPage" :limit="limit" :array="filters" @change="pageChange"
                    @limitChange="limitChange"></pagination>
    </div>
</template>

<script>
    import SearchBar from "@/components/SearchBar";
    import Btn from "@/components/Btn";
    import axios from 'axios';
    import tools from '../config.ts';
    import moment from 'moment';
    import MultiListSelect from "vue-search-select/src/lib/MultiListSelect";
    import Pagination from "@/components/Pagination";
    import Loader from "@/components/Loader";
    import TableOrder from "@/components/TableOrder";
    import DatePicker from 'v-calendar/lib/components/date-picker.umd'

    export default {
        name: "Calls",
        components: {TableOrder, Pagination, MultiListSelect, Btn, SearchBar, Loader, DatePicker},
        data() {
            return {
                calls: [],

                customers: [],
                customersSelect: [],
                reasons: [],
                reasonsSelect: [],
                users: [],
                usersSelect: [],

                currentPage: 0,
                limit: 100,
                order: {order: 'desc', name: 'date_hours_start'},

                date_end: moment().format("YYYY-MM-DD"),
                date_start: moment().subtract(1, "days").format("YYYY-MM-DD"),

                locals: ["customers", "customersSelect", "reasons", "reasonsSelect", "users", "usersSelect", "currentPage", "date_start", "date_end", "order"],
                cookies: ["limit"],

                stickyTop: 0,
                loaded:false,
            }
        },
        methods: {
            load() {

                let config = tools.headerPOST();
                let speed = "";
                let currentloaded = 0;
                let startTime = new Date().getTime();
                config.onDownloadProgress = (progressEvent) => {

                    const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');

                    let loaded = tools.toByte(progressEvent.loaded)

                    let total = tools.toByte(totalLength);


                    if(new Date().getTime() - startTime > 1000){

                        speed = tools.toByte(progressEvent.loaded - currentloaded);
                        startTime = new Date().getTime();
                        currentloaded = progressEvent.loaded;
                    }

                    tools.$emit("loader-download","Téléchargement : "+loaded+" / "+total+" ("+speed+"/s)");
                    tools.$emit("loader-progress",Math.round( (progressEvent.loaded * 100) / totalLength ));

                };

                tools.loader(true);
                axios.post(tools.api("calls"), tools.toPOST({
                    customers: this.customersSelect.map((customer) => customer.id).join(","),
                    reasons: "", //this.reasonsSelect.map((reason) => reason.id).join(","),
                    users: this.usersSelect.map((reason) => reason.id).join(","),
                    date_start: this.date_start,
                    date_end: this.date_end,
                }), config)
                    .then(response => {

                        tools.$emit("loader-download","Traitement des données...");
                        tools.$emit("loader-progress",0);

                        setTimeout(() => {
                            this.calls = response.data;

                            this.calls.map((call) => {
                                call.date_hours_start = this.dateHours(call.date_start,call.hour_start);
                                call.date_hours_validation = this.dateHours(call.date_validation,call.hour_validation);
                            });

                            tools.saveLocals("calls", this);

                            tools.loader(false);
                            this.loaded = true;

                        },1)

                    })
                    .catch((e) => {
                        tools.loader(false);
                        this.loaded = true;
                    })
            },
            callReasonResume(call){
                if(call.reasons && call.reasons.length > 0){
                    let labels = [];
                    call.reasons.forEach((c) => {
                        labels.push(c.label)
                    })
                    return labels.join(', ')
                }
                if(call.reason) return call.reason.label;
            },
            editLimit(call){
                return tools.editLimit(call);
            },
            user(user) {
                if (user.firstname && user.lastname) {
                    return user.firstname+" "+user.lastname;
                }

                return user.login;
            },
            onSelectCustomer(items) {
                this.customersSelect = items;
                this.load();
            },
            onSelectReason(items) {
                this.reasonsSelect = items;
                // this.load();
            },
            onSelectUser(items) {
                this.usersSelect = items;
                this.load();
            },
            pageChange(page) {
                this.currentPage = page;
                tools.saveLocals("calls", this);
            },
            show(call) {
                if(call.reason.id) {
                    this.$router.push("call/" + call.id + "/show")
                }else{
                    this.$router.push("call-v2/" + call.id + "/show")
                }
            },
            edit(call) {

                if(!tools.editLimit(call) && this.$store.getters.hasPerm("call:show")){
                    return this.show(call)
                }

                if(call.reason.id) {
                    this.$router.push("call/" + call.id + "/edit")
                }else{
                    this.$router.push("call-v2/" + call.id + "/edit")
                }
            },
            resetSearch() {

                this.customersSelect = [];
                this.reasonsSelect = [];

                if (this.$store.getters.hasPerm('call:add/edit:user')) {
                    this.usersSelect = [];
                }

                this.date_end = moment().format("YYYY-MM-DD");
                this.date_start = moment().subtract(1, "days").format("YYYY-MM-DD");
                this.currentPage = 0;
                this.order = {
                    order: 'desc',
                    name: 'date_hours_start'
                };

                tools.$emit("orderChange", this.order);
                this.load();
            },
            changeOrder(data) {
                this.order = {
                    order: data.order,
                    name: data.name
                }
                tools.saveLocals("calls", this);
            },
            limitChange(limit) {

                this.limit = limit;
                this.currentPage = 0;

                tools.saveCookies("calls", this);
            },
            dateHours(date,hour) {
                return moment(date+" "+hour,"YYYY-MM-DD HH:mm:ss")
                // return this.$options.filters.formatDate(date) + " " + this.$options.filters.formatHour(hour)
            },
            exports(arrData) {
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    Object.keys(arrData[0]).join(";"),
                    ...arrData.map(item => Object.values(item).join(";"))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "export_calls_"+moment().format("YYYYMMDD_HHmmss")+".csv");
                link.click();
            },
            stats(arrData) {
                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    Object.keys(arrData[0]).join(";"),
                    ...arrData.map(item => Object.values(item).join(";"))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "stats_calls_"+moment().format("YYYYMMDD_HHmmss")+".csv");
                link.click();
            },
            calculCallMeet(call){
                if(!call.reasons || call.reasons.length <= 0) {
                    // console.log(call)
                    return call.call_meet;
                }
                
                let nb = 0
                call.reasons.forEach(reason => {
                    let n = parseInt(reason.call_meet)
                    if(isNaN(n)) return;
                    nb += n
                })
                if(nb === 0) return "";
                return nb;
            }
        },
        watch: {
            // date_start() {
            //     this.load();
            // },
            // date_end() {
            //     this.load();
            // },
            limit() {
                console.log("change : " + this.limit)
            },
            dateRange() {
                if(!this.loaded) return;

                // console.log("change");
                this.load();
            }
        },
        computed: {
            filters() {
                tools.sortArray(this.calls, this.order);
                
                let calls = this.calls;
                
                if(this.reasonsSelect.length > 0) {
                    calls = this.calls.filter((c) => {
                        return c.reasons.find(r => {
                            return this.reasonsSelect.find(rs => {
                                return rs.id === r.id
                            })
                        })
                    })
                }
                
                return calls;
            },
            visibles() {
                return this.filters.slice(this.currentPage * this.limit, (this.currentPage * this.limit) + parseInt(this.limit));
            },
            dateRange: {
                set(newDate) {
                    this.date_start = moment(newDate.start).format("YYYY-MM-DD");
                    this.date_end = moment(newDate.end).format("YYYY-MM-DD");
                },
                get() {
                    return {
                        start: moment(this.date_start).toDate(),
                        end: moment(this.date_end).toDate(),
                    }
                }
            },
            csvData() {
                return this.calls.map(item => {
                    return {
                        "id": item.id,
                        "Date d'appel": item.date_start,
                        "Heure d'appel": item.hour_start,
                        "Date de validation": item.date_validation,
                        "Heure de validation": item.hour_validation,
                        "Client": item.customer.company,
                        "Motif d'appel": item.reason.label,
                        "Nom Patient": item.call_name ? item.call_name.replace(/[\t\n\[\]#\{\}]/g, "") : "",
                        "Naissance Patient": item.call_birthday,
                        "Telephone Patient": item.phone_number,
                        "Observation": item.observation ? item.observation.replace(/[\t\n\[\]#\{\}]/g, "") : "",
                        "Nb RdV": item.call_meet,
                        "Utilisateur": item.user.firstname + " " + item.user.lastname,
                    }
                });
            },
            csvStats() {

                let stats = {};
                let total = {};

                this.calls.forEach((item) => {
                    if(!stats[item.customer.company]){
                        stats[item.customer.company] = {};
                        total[item.customer.company] = {
                            nbAppel :0,
                            rdvReel :0,
                            rdvVirtuel :0,
                        };
                    }
                    if(!stats[item.customer.company][item.reason.label]){
                        stats[item.customer.company][item.reason.label] = {
                            nbAppel :0,
                            rdvReel :0,
                            rdvVirtuel :0,
                        };
                    }
                    let nbCall = parseInt(item.call_meet);

                    if(isNaN(nbCall) || nbCall === 0){
                        nbCall = 1;
                    }else{
                        total[item.customer.company]["rdvReel"] += nbCall;
                        stats[item.customer.company][item.reason.label]["rdvReel"] += nbCall;
                    }

                    total[item.customer.company]["nbAppel"] += 1;
                    total[item.customer.company]["rdvVirtuel"] += nbCall;
                    
                    stats[item.customer.company][item.reason.label]["nbAppel"] += 1;
                    stats[item.customer.company][item.reason.label]["rdvVirtuel"] += nbCall;
                });

                let csv = [];

                for (const [customer, stat] of Object.entries(stats)) {
                    for (const [reason, count] of Object.entries(stat)) {
                        csv.push({
                            "Client" : customer,
                            "Motif d'appel" : reason,
                            "Total des appels (nb ligne)" : count.nbAppel,
                            "Total des rdv (renseigne)" : count.rdvReel,
                            "Total des rdv (extrapole)" : count.rdvVirtuel,
                        })
                    }
                }

                csv.push({
                    "Client" : "",
                    "Motif d'appel" : "",
                    "Total des appels (nb ligne)" : "",
                    "Total des rdv (renseigne)" : "",
                    "Total des rdv (extrapole)" : "",
                })

                for (const [customer, count] of Object.entries(total)) {

                    csv.push({
                        "Client" : customer,
                        "Motif d'appel" : "Total des appels",
                        "Total des appels (nb ligne)" : count.nbAppel,
                        "Total des rdv (renseigne)" : count.rdvReel,
                        "Total des rdv (extrapole)" : count.rdvVirtuel,
                    })

                }

                return csv;

            }
        },
        mounted() {

            if (!this.$store.getters.hasPerm("call:list")) {
                console.log(this.$store.getters.getUser)
                if(this.$store.getters.getUser.customer_id.length > 0){
                    return this.$router.push("/questionnaires");
                }
                return this.$router.back();
            }

            tools.loader(true);
            this.stickyTop = this.$refs.top.getBoundingClientRect().top + this.$refs.top.clientHeight;

            window.addEventListener('resize', () => {
                this.stickyTop = this.$refs.top.getBoundingClientRect().top + this.$refs.top.clientHeight;
            });

            // console.log(this.stickyTop);

            this.$store.commit("onEditMode", false);

            tools.setLocals("calls", this);
            tools.setCookies("calls", this);

            tools.$emit("orderChange", this.order);

            // this.load();

            // if can't change user in calls list
            if (!this.$store.getters.hasPerm('call:add/edit:user')) {
                this.usersSelect = [this.$store.getters.getUser]
            }

            // customers load for search bar
            let customer = axios.get(tools.api("customers"), tools.headerGET())
                .then(response => {
                    this.customers = response.data;
                });

            // reasons load for search bar
            let reasons = axios.get(tools.api("reasons"), tools.headerGET())
                .then(response => {
                    this.reasons = response.data;
                });

            // users load for search bar
            let users = axios.get(tools.api("users"), tools.headerGET())
                .then(response => {
                    this.users = response.data;
                });

            Promise.all([customer, reasons, users])
                .then(() => {
                    this.load();
                })
        }
    }
</script>

<style scoped>

    .top .options .searchBar.drop{
        height:auto !important;
    }
</style>